export default __webpack_public_path__ + "search-examples-search-ui-and-maps-sdk-thumbnail-960-f303690e7b4327d38a2a9b8c55253d9a.png";